import { memberSourceCreate } from '../api/shopmember';
import { toast } from '../utils/prompt';
import globalStoreData from '../store/index';

const TAG = 'member-utils.js';

// activityId (string, optional):活动ID ,
// id (string):会员ID ,
// recommenderId (string, optional):推荐人ID ,
// source (string, optional):来源，LOTTERY-0元抽奖 = ['LOTTERY']
export const memberSourceCreateRequest = async function() {
  let result = '';
  if (globalStoreData.memberSource) {
    const activityId = globalStoreData.memberSource.activityId || '';
    const recommenderId = globalStoreData.memberSource.recommenderId || '';
    const source = globalStoreData.memberSource.source || '';
    result = await memberSourceCreate(activityId, recommenderId, source);
    globalStoreData.memberSource = null;
  } else {
    result = await memberSourceCreate();
  }
};

export default {
  memberSourceCreateRequest,
};
